<template>
  <div class="back">
    <div class="syb" @click="fhbtn">
      <van-icon name="arrow-left" color="#ee0a24" class="arrow" />
      <span class="fh">返回</span>
    </div>
    <div @click="sybtn">
      <span class="fh sy" v-if="homefalg">返回首页</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['homeShow'],
  data() {
    return {
      homefalg: this.homeShow == false?this.homeShow:true
    }
  },
  methods: {
    fhbtn(){
      console.log(111,this.homeShow)
      this.$router.back()
    },
    sybtn(){
      this.$router.push('/index')
    }
  },
}
</script>

<style lang="less" scoped>
.back{
  width: 100%;
  height: 40px;
  background: #EDEDED;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  .syb{
    display: flex;
    align-items: center;
  }
  .arrow{
    padding: 0px 6px 0px 4px;
    font-size: 26px;
  }
  .fh{
    font-size: 18px;
    letter-spacing: 1px;
  }
  // .sy{
  //   position: absolute;
  //   right: 20px;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/lastpage/lastpage.vue